<template>
  <v-container>
    <v-card class="px-2">
      <v-row>
        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            v-model="codigo"
            label="Cod galeria"
            outlined
            dense
            @change="loadUpdate()"
          >
            <v-btn
              class="btn-outer-right-1 pa-0"
              slot="append-outer"
              color="success"
              tile
              @click.prevent="loadDialog"
            >
              <v-icon
                class="mx-0"
                color="white"
              >
                mdi-magnify
              </v-icon>
            </v-btn>
          </v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            v-model="codMenu"
            label="Cod lista de menu"
            outlined
            dense
            @change="loadSelMenu()"
          >
            <v-btn
              class="btn-outer-right-1 pa-0"
              slot="append-outer"
              color="success"
              tile
              @click.prevent="loadDialogMenu"
            >
              <v-icon
                class="mx-0"
                color="white"
              >
                mdi-magnify
              </v-icon>
            </v-btn>
          </v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="8"
        >
          <v-card-text class="py-0 mt-0">Menú lista<h4>{{ nmenu }}</h4>
          </v-card-text>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            v-model="codNoticia"
            label="Cod notícia"
            outlined
            dense
            @change="loadSelNoticia()"
          >
            <v-btn
              class="btn-outer-right-1 pa-0"
              slot="append-outer"
              color="success"
              tile
              @click.prevent="loadDialogNoticia"
            >
              <v-icon
                class="mx-0"
                color="white"
              >
                mdi-magnify
              </v-icon>
            </v-btn>
          </v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="8"
        >
          <v-card-text class="py-0 mt-0">Notícia<h4>{{ ntitulo }}</h4>
          </v-card-text>
        </v-col>
      </v-row>
      <form-galeria
        :galeria="galeria"
        :subcategorias="subcategorias"
        :tipoGaleria="tipoGaleria"
        :mode="mode"
      />
      <v-card>
        <v-card-title>
          Fotos ou vídeos da galeria
        </v-card-title>
        <v-data-table
          :headers="headersFoto"
          :items="fotos"
          fixed-header
          height="200px"
          dense
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              size="30"
              color="success"
              class="mr-2"
              @click="loadFoto(item)"
            >
              mdi-square-edit-outline
            </v-icon>
          </template>
        </v-data-table>
        <v-card-actions
          v-if="galeria.id"
          class="justify-end"
        >
          <v-btn
            color="success"
            class="ml-4 mb-2"
            v-if="galeria.tipo === 'Fotos'"
            @click="loadAddFoto"
          >
            <v-icon left>
              mdi-camera-outline
            </v-icon>
            Adicionar imagem
          </v-btn>
          <v-btn
            color="success"
            class="ml-4 mb-2"
            v-if="galeria.tipo === 'Videos'"
            @click="loadAddVideo"
          >
            <v-icon left>
              mdi-video-outline
            </v-icon>
            Adicionar Video
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card-actions class="justify-start">
        <v-btn
          color="success"
          class="ml-1 mr-4"
          v-if="mode === 'save'"
          @click.prevent="save"
        >
          <v-icon left>
            mdi-content-save-outline
          </v-icon>
          Salvar
        </v-btn>
        <v-btn
          color="success"
          class="ml-1 mr-4"
          v-if="mode === 'editar'"
          @click.prevent="save"
        >
          <v-icon left>
            mdi-content-save-edit-outline
          </v-icon>
          Atualizar
        </v-btn>
        <v-btn
          color="secondary"
          class="mr-4"
          @click="reset()"
        >
          <v-icon left>
            mdi-broom
          </v-icon>
          Limpar
        </v-btn>
        <v-btn
          v-if="galeria.id"
          color="error"
          class="mr-4"
          @click="remove"
        >
          <v-icon left>
            mdi-trash-can-outline
          </v-icon>
          Deletar
        </v-btn>
      </v-card-actions>
    </v-card>
    <!-- Dialog de filtro de galerias -->
    <v-container>
      <v-dialog
        v-model="dialog"
        transition="dialog-bottom-transition"
        fullscreen
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Pesquisar galerias
            </v-toolbar>
            <v-card-title>
              <v-text-field
                class="search"
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
              >
              </v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="galerias"
              :search="search"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  large
                  color="success"
                  class="mr-2"
                  @click="loadUpdate(item)"
                >
                  mdi-arrow-down-bold-box
                </v-icon>
              </template>
            </v-data-table>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                @click="dialog.value = false"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
    <!-- Dialog de filtro de menus -->
    <v-container>
      <v-dialog
        v-model="dialogMenu"
        transition="dialog-bottom-transition"
        fullscreen
      >
        <template v-slot:default="dialogMenu">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Pesquisar menus dinâmicos
            </v-toolbar>
            <v-card-title>
              <v-text-field
                class="search"
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
              >
              </v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headerMenu"
              :items="menus"
              :search="search"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  large
                  color="success"
                  class="mr-2"
                  @click="loadSelMenu(item)"
                >
                  mdi-arrow-down-bold-box
                </v-icon>
              </template>
            </v-data-table>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                @click="dialogMenu.value = false"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
    <!-- Dialog de filtro de notícias -->
    <v-container>
      <v-dialog
        v-model="dialogNoticia"
        transition="dialog-bottom-transition"
        fullscreen
      >
        <template v-slot:default="dialogNoticia">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Pesquisar galerias
            </v-toolbar>
            <v-card-title>
              <v-text-field
                class="search"
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
              >
              </v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headerNoticia"
              :items="noticias"
              :search="search"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  large
                  color="success"
                  class="mr-2"
                  @click="loadSelNoticia(item)"
                >
                  mdi-arrow-down-bold-box
                </v-icon>
              </template>
            </v-data-table>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                @click="dialogNoticia.value = false"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
    <!-- Dialog de editar dados da foto -->
    <v-container>
      <v-dialog
        v-model="dialogFoto"
        transition="dialog-top-transition"
      >
        <template v-slot:default="dialogFoto">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Atualizar dados da imagem
            </v-toolbar>
            <v-card
              elevation="2"
              class="pa-3"
            >
              <div class="ma-5">
                <v-form>
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="codFoto"
                        label="Código"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      v-if="galeria.id"
                    >
                      <v-checkbox
                        v-model="foto.inativar"
                        label="inativar imagem?"
                        color="success"
                        class="mt-0 mb-2"
                      >
                      </v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      v-if="galeria.id"
                    >
                      <v-checkbox
                        v-model="foto.publico_privado"
                        label="Imagem privada?"
                        color="success"
                        class="mt-0 mb-2"
                      >
                      </v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="7"
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          md="8"
                        >
                          <v-text-field
                            v-model="foto.imagem"
                            label="Nome da foto"
                            dense
                            outlined
                          >
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-mask="dtpub"
                                v-model="data_publicacao"
                                label="Data de publicação.:"
                                dense
                                outlined
                                @blur="mudaDataMidia"
                              >
                                <v-icon
                                  slot="append"
                                  color="success"
                                  large
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-calendar
                                </v-icon>
                              </v-text-field>
                            </template>
                            <v-date-picker
                              locale="pt-br"
                              v-model="date"
                              @input="dateF"
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-autocomplete
                            v-model="foto.uid_subcategoria"
                            :items="subcategorias"
                            disabled
                            dense
                            outlined
                            label="Subcategoria da vinculada"
                          >
                          </v-autocomplete>
                        </v-col>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-autocomplete
                            v-model="foto.uid_fotografo"
                            :items="fotografos"
                            hide-selected
                            dense
                            outlined
                            @blur="loadSubCategorias()"
                            label="Fotógrafo"
                          >
                            <v-icon
                              class="mr-2"
                              slot="append"
                              color="black"
                              v-if="foto.uid_fotografo"
                              @click.prevent="limparBoxes()"
                            >
                              mdi-close
                            </v-icon>
                            <v-btn
                              class="btn-outer  ml-2 pa-0"
                              slot="append"
                              color="success"
                              tile
                            >
                              <v-icon
                                class="mx-0"
                                color="white"
                              >
                                mdi-magnify
                              </v-icon>
                            </v-btn>
                            <v-btn
                              class="btn-outer-right pa-0"
                              slot="append"
                              color="light"
                              tile
                              :disabled="Boolean(noticia.uid_categoria)"
                              @click="loadAddCategoria"
                            >
                              <v-icon
                                class="mx-0"
                                color="black"
                              >
                                mdi-plus
                              </v-icon>
                            </v-btn>
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          md="12"
                        >
                          <v-text-field
                            v-model="foto.url"
                            label="Link da imagem ou video"
                            dense
                            outlined
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          md="12"
                        >
                          <v-textarea
                            v-model="foto.ds_foto"
                            label="Informações da foto"
                            auto-grow
                            outlined
                            rows="3"
                            row-height="25"
                            dense
                          >
                          </v-textarea>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          md="12"
                        >
                          <v-card-text class="py-0 mt-0">Esta foto pertence à notícia de código.: <strong>{{ codNoticia }}</strong>
                          </v-card-text>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          md="5"
                          v-if="foto.uid_galeria"
                        >
                          <v-card-text class="py-0 mt-0">E está vinculada na galeria.: <strong>{{ foto.uid_galeria }}</strong>
                          </v-card-text>
                        </v-col>
                        <v-col
                          cols="12"
                          md="5"
                          v-else
                        >
                          <v-card-text class="py-0 mt-0">Esta foto não pertence a nenhuma galeria
                          </v-card-text>
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <v-checkbox
                            v-model="foto.vinc_galeria"
                            label="Vincular na galeria?"
                            color="success"
                            class="mt-0 mb-2"
                            @change="desvinculaGaleria"
                          >
                          </v-checkbox>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="12"
                      md="5"
                      v-if="foto.embed"
                    >
                      <v-card class="pa-2">
                        <iframe
                          width="560"
                          height="315"
                          :src="foto.url"
                          title="YouTube video player"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowfullscreen
                        ></iframe>
                      </v-card>
                    </v-col>
                    <v-col
                      cols="12"
                      md="5"
                      v-else
                    >
                      <v-card class="pa-2">
                        <v-img :src="foto.url">
                        </v-img>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="ml-1 mr-4"
                  v-if="!codFoto"
                  @click.prevent="editImagem()"
                >
                  <v-icon left>
                    mdi-content-save-outline
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="success"
                  class="ml-1 mr-4"
                  v-if="codFoto"
                  @click.prevent="editImagem()"
                >
                  <v-icon left>
                    mdi-content-save-edit-outline
                  </v-icon>
                  Atualizar
                </v-btn>
                <v-btn
                  color="secondary"
                  class="mr-4"
                  @click="resetFoto()"
                >
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                  Limpar
                </v-btn>
                <v-btn
                  v-if="!foto.uid_noticia"
                  color="error"
                  class="mr-4"
                  @click="removeFoto"
                >
                  <v-icon left>
                    mdi-trash-can-outline
                  </v-icon>
                  Deletar
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="dialogFoto.value = false"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
    <!-- Dialog de adicionar foto -->
    <v-container>
      <v-dialog
        v-model="addFoto"
        transition="dialog-top-transition"
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Adicionar imagem ou video
            </v-toolbar>
            <v-card
              elevation="2"
              class="pa-3"
            >
              <div class="ma-5">
                <PageTitle
                  icon="mdi-pencil-box-outline"
                  sub="Imagens da notícia"
                />
                <v-form>
                  <input
                    id="user-id"
                    type="hidden"
                    v-model="foto.usuario"
                  />
                  <input
                    id="foto-id"
                    type="hidden"
                    v-model="foto.id"
                  />
                  <input
                    id="foto-uuid"
                    type="hidden"
                    v-model="foto.uuid"
                  />
                  <input
                    id="uid_noticia"
                    type="hidden"
                    v-model="foto.uuid_noticia"
                  />
                  <input
                    id="uid_noticia"
                    type="hidden"
                    v-model="foto.uid_noticia"
                  />
                  <input
                    id="uid_galeria"
                    type="hidden"
                    v-model="foto.uid_galeria"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="galeria.id"
                        label="Código"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      v-if="foto.id"
                    >
                      <v-checkbox
                        v-model="foto.inativar"
                        label="Inativar Foto?"
                        color="success"
                        class="mt-0 mb-2"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      v-if="galeria.id"
                    >
                      <v-checkbox
                        v-model="foto.slide"
                        label="Imagem de slide ?"
                        color="success"
                        class="mt-0 mb-2"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      v-if="galeria.id"
                    >
                      <v-checkbox
                        v-model="foto.capa"
                        label="Imagem de capa ?"
                        color="success"
                        class="mt-0 mb-2"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      v-if="galeria.id"
                    >
                      <v-checkbox
                        v-model="foto.vinc_galeria"
                        label="Vinc. na galeria ?"
                        color="success"
                        class="mt-0 mb-2"
                        @change="desvinculaGaleria"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="5"
                    >
                      <v-text-field
                        v-model="foto.imagem"
                        label="Nome da foto"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="5"
                    >
                      <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-mask="dtpub"
                            v-model="data_publicacao"
                            label="Data de publicação.:"
                            dense
                            outlined
                            @blur="mudaDataMidia"
                          >
                            <v-icon
                              slot="append"
                              color="success"
                              large
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-calendar
                            </v-icon>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          locale="pt-br"
                          v-model="date"
                          @input="dateF"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="5"
                    >
                      <v-autocomplete
                        v-model="foto.uid_subcategoria"
                        :items="subcategorias"
                        disabled
                        dense
                        outlined
                        label="Subcategoria vinculada"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="5"
                    >
                      <v-autocomplete
                        v-model="foto.uid_fotografo"
                        :items="fotografos"
                        hide-selected
                        dense
                        outlined
                        @blur="loadSubCategorias()"
                        label="Fotógrafo"
                      >
                        <v-icon
                          class="mr-2"
                          slot="append"
                          color="black"
                          v-if="foto.uid_fotografo"
                          @click.prevent="limparBoxes()"
                        >
                          mdi-close
                        </v-icon>
                        <v-btn
                          class="btn-outer  ml-2 pa-0"
                          slot="append"
                          color="success"
                          tile
                        >
                          <v-icon
                            class="mx-0"
                            color="white"
                          >
                            mdi-magnify
                          </v-icon>
                        </v-btn>
                        <v-btn
                          class="btn-outer-right pa-0"
                          slot="append"
                          color="light"
                          tile
                          :disabled="Boolean(noticia.uid_categoria)"
                          @click="loadAddCategoria"
                        >
                          <v-icon
                            class="mx-0"
                            color="black"
                          >
                            mdi-plus
                          </v-icon>
                        </v-btn>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="foto.url"
                        label="Url da imagem ou video"
                        outlined
                        dense
                        @change="loadUrl"
                      >
                        <v-icon
                          v-if="foto.url"
                          class="mx-0 pa-0"
                          slot="append"
                          color="success"
                          @click="clearUrl"
                        >
                          mdi-close
                        </v-icon>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-textarea
                        v-model="foto.embed"
                        label="Embed"
                        auto-grow
                        outlined
                        rows="3"
                        row-height="25"
                        dense
                        persistent-hint
                        hint="Este campo é apenas para video incorporado"
                      >
                      </v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="foto.ds_foto"
                        label="Informações da foto"
                        outlined
                        dense
                        @change="loadUrl"
                      >
                        <v-icon
                          v-if="foto.url"
                          class="mx-0 pa-0"
                          slot="append"
                          color="success"
                          @click="clearUrl"
                        >
                          mdi-close
                        </v-icon>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="verCapUp === true">
                    <input
                      accept="image/png, image/jpg, image/jpeg, image/bmp"
                      prepend-icon="mdi-camera"
                      label="Arquivo de imagem"
                      v-if="uploadReady"
                      type="file"
                      ref="file"
                      @change="selectFile()"
                    >
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <div v-if="galeria.id">
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="verCapUp === true"
                    type="submit"
                    @click.prevent="fileUpload()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar
                  </v-btn>
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="verCapUp === false"
                    type="submit"
                    @click="saveImage()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar
                  </v-btn>
                </div>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="galeria.id"
                  @click="clearUpload"
                >
                  Remover
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="secondary"
                  class="mr-4"
                  @click="resetFoto()"
                >
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                  Limpar
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="dialog.value = false"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import { baseApiUrl, showError } from '@/global'
// import moment from 'moment'
import axios from 'axios'
import FormGaleria from '../forms/FormGaleria.vue'
import moment from 'moment'
export default {
  components: { FormGaleria },
  name: 'ListGaleria',
  computed: mapState(['user']),
  data: () => ({
    mode: 'save',
    grupo: '1',
    nmenu: '[Menú não informado]',
    ntitulo: '[Título não informado]',
    codigo: '',
    codFoto: '',
    codNoticia: '',
    codMenu: '',
    verCapUp: true,
    video: null,
    dialog: false,
    addFoto: false,
    addVideo: false,
    dialogFoto: false,
    dialogNoticia: false,
    dialogMenu: false,
    dtpub: '##/##/####',
    date: new Date().toISOString().substr(0, 10),
    data_publicacao: '',
    menu: false,
    uploadReady: true,
    file: '',
    tabela: 'imgnoticias',
    search: '',
    noticia: {},
    noticias: [],
    galeria: {},
    galerias: [],
    fotos: [],
    fotografos: [],
    foto: {},
    menus: [],
    menuSelect: {},
    subcategorias: [],
    tipoGaleria: [
      { value: 'Fotos', text: 'Fotos' },
      { value: 'Videos', text: 'Videos' }
    ],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Tipo de galeria', value: 'tipo' },
      { text: 'Título', value: 'titulo' },
      { text: 'Situação', value: 'situacao' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headerMenu: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'name' },
      { text: 'Bloco', value: 'bloco', sortable: false },
      { text: 'Menu', value: 'path', sortable: false },
      { text: 'Data publicação', value: 'data' },
      { text: 'Link externo', value: 'linkint', sortable: false },
      { text: 'Situação', value: 'inativo', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headerNoticia: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Título', value: 'titulo' },
      { text: 'Publicado', value: 'publicar', sortable: false },
      { text: 'Data publicação', value: 'data' },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Ativo' : 'Inativo'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersFoto: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'imagem' },
      { text: 'Privada', value: 'publica' },
      { text: 'Capa', value: 'capa' },
      { text: 'Slide', value: 'slide' },
      { text: 'Vinc notícia', value: 'noticia' },
      { text: 'Vinc galeria', value: 'galeria' },
      { text: 'Data de publicação', value: 'data' },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ]
  }),
  methods: {
    dateF () {
      this.data_publicacao = moment(this.date).format('DD/MM/YYYY')
      this.menu = false
    },
    mudaDataMidia () {
      const [dia, mes, ano] = this.data_publicacao.split('/')
      this.date = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async fileUpload () {
      const idN = this.galeria.uid_noticia
      const formData = new FormData()
      const url = `${baseApiUrl}/imagem-da-noticia`
      formData.append('uuid', this.foto.uuid)
      formData.append('uuid_noticia', this.foto.uuid_noticia)
      formData.append('uid_noticia', this.foto.uid_noticia)
      // formData.append('vinc_noticia', this.foto.vinc_noticia)
      formData.append('uid_galeria', this.foto.uid_galeria)
      formData.append('vinc_galeria', this.foto.vinc_galeria)
      formData.append('imagem', this.foto.imagem)
      formData.append('capa', this.foto.capa || 0)
      formData.append('uid_fotografo', this.foto.uid_fotografo || 0)
      formData.append('ds_foto', this.foto.ds_foto)
      formData.append('data_publicacao', this.date)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.foto.uid_noticia)
      formData.append('usuario', this.foto.usuario)
      formData.append('file', this.file)
      await axios.post(url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadFotos(idN)
          this.resetUpload()
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    resetUpload () {
      this.file = ''
      this.foto = {}
      this.foto.uuid = uuid.v1()
      this.foto.vinc_galeria = true
      this.foto.usuario = this.user.id
      this.foto.uuid_noticia = this.noticia.uuid
      this.foto.uid_noticia = this.noticia.id
      this.foto.uid_galeria = this.galeria.uid_galeria
      this.doc = {}
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    save () {
      const method = this.galeria.id ? 'put' : 'post'
      const id = this.galeria.id ? `/${this.galeria.id}` : ''
      axios[method](`${baseApiUrl}/galeria-da-noticia${id}`, this.galeria)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    editImagem () {
      var nt = this.galeria.uid_noticia
      const idN = nt || this.galeria.id
      this.foto.data_publicacao = this.date
      const method = this.foto.id ? 'put' : 'post'
      const id = this.foto.id ? `/${this.foto.id}` : ''
      axios[method](`${baseApiUrl}/imagens-de-noticia${id}`, this.foto)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.foto = {}
          this.loadFotos(idN)
          this.verCapUp = true
        })
        .catch(showError)
    },
    remove () {
      const id = this.galeria.id
      if (confirm('Deseja realmente deletar esta galeria?')) {
        axios.delete(`${baseApiUrl}/galeriass/${id}`)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.reset()
          })
          .catch(showError)
      }
    },
    removeFoto () {
      const id = this.foto.id
      if (confirm('Deseja realmente deletar esta foto?')) {
        axios.delete(`${baseApiUrl}/fotosssss/${id}`)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.reset()
          })
          .catch(showError)
      }
    },
    loadSelNoticia (item) {
      const id = this.codNoticia ? this.codNoticia : item.id
      const url = `${baseApiUrl}/noticias-filtro-update/${id}`
      axios.get(url).then(res => {
        this.noticia = res.data
        this.ntitulo = this.noticia.titulo
        this.galeria.uid_noticia = this.noticia.id
        this.codNoticia = this.noticia.id
        this.loadSubCategorias()
      })
      this.dialogNoticia = false
    },
    loadSelMenu (item) {
      const id = this.codMenu ? this.codMenu : item.id
      const url = `${baseApiUrl}/menu-categorias/${id}`
      axios.get(url).then(res => {
        this.menuSelect = res.data
        this.galeria.uuid_menu = this.menuSelect.uuid
        this.galeria.uid_menu = this.menuSelect.id
        this.codMenu = this.menuSelect.id
      })
      this.dialogMenu = false
      this.nmenu = item.path
      this.galeria.path = item.path
    },
    loadUpdate (item) {
      const idB = item.uuid
      const url = `${baseApiUrl}/galeria-de-noticia-update/${idB}`
      axios.get(url).then(res => {
        this.galeria = res.data
        this.codigo = this.galeria.id
        this.codMenu = this.galeria.uid_menu
        this.nmenu = this.galeria.path
        const idN = this.galeria.uid_noticia
        this.loadNoticia(idN)
        this.loadFotos(idN)
        this.loadFotografos()
      })
      this.dialog = false
      this.mode = 'editar'
    },
    loadNoticia (idN) {
      const url = `${baseApiUrl}/noticias-filtro-update/${idN}`
      axios.get(url).then(res => {
        this.noticia = res.data
        this.ntitulo = this.noticia.titulo
        this.galeria.uid_noticia = this.noticia.id
        this.codNoticia = this.noticia.id
        this.loadSubCategorias()
      })
    },
    loadMenu (idN) {
      const url = `${baseApiUrl}/noticias-filtro-update/${idN}`
      axios.get(url).then(res => {
        this.noticia = res.data
        this.nmenu = this.noticia.titulo
        this.galeria.uid_noticia = this.noticia.id
        this.codMenu = this.noticia.id
      })
    },
    loadDialog () {
      this.dialog = true
      this.galeria = {}
      this.codigo = ''
      this.codFoto = ''
      this.loadGalerias()
    },
    clearUrl () {
      this.foto.url = ''
      if (!this.video) {
        this.loadUrl()
      }
    },
    loadUrl () {
      var url = this.foto.url
      if (url === '') {
        this.verCapUp = true
      } else {
        this.verCapUp = false
      }
    },
    resetFoto () {
      this.foto = {}
      this.verCapUp = true
      this.loadDatas()
    },
    limparBoxes () {
      this.foto.uid_fotografo = null
    },
    loadFoto (item) {
      const id = item.id
      const url = `${baseApiUrl}/fotos-update-galeria/${id}`
      axios.get(url).then(res => {
        this.foto = res.data
        this.data_publicacao = moment(this.foto.data_publicacao).format('DD/MM/YYYY')
        this.codFoto = this.foto.id
        this.date = moment(this.foto.data_publicacao).format('YYYY-MM-DD')
        this.foto.uid_subcategoria = this.galeria.uid_subcategoria
      })
      this.dialogFoto = true
      this.loadFotografos()
    },
    loadDialogNoticia () {
      this.dialogNoticia = true
      this.codNoticia = ''
      this.loadNoticias()
    },
    loadDialogMenu () {
      this.dialogMenu = true
      this.codMenu = ''
      this.loadMenus()
    },
    loadNoticias () {
      const url = `${baseApiUrl}/noticias`
      axios.get(url).then(res => {
        this.noticias = res.data.map(item => {
          return {
            ...item,
            publicar: item.publicar === 0 ? 'Publicado' : 'Não publicado',
            inativar: item.inativar === 0 ? 'Ativo' : 'Inativo',
            data: moment(item.data_publicacao).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadMenus () {
      const gp = this.grupo
      const url = `${baseApiUrl}/menu-categorias-por-grupo/${gp}`
      axios.get(url).then(res => {
        this.menus = res.data.map(item => {
          return {
            ...item,
            linkint: item.publicar === 0 ? 'Sim' : 'Não',
            inativo: item.inativar === 0 ? 'Ativo' : 'Inativo',
            data: moment(item.created_at).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadGalerias () {
      const url = `${baseApiUrl}/galeria-da-noticia`
      axios.get(url).then(res => {
        this.galerias = res.data.map(item => {
          return {
            ...item,
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadSubCategorias () {
      const uid = this.noticia.uid_categoria
      const url = `${baseApiUrl}/subcategorias-da-categoria/${uid}`
      axios.get(url).then(res => {
        this.subcategorias = res.data.map(subcat => {
          return {
            value: subcat.id,
            text: subcat.ds_subcategoria
          }
        })
      })
    },
    loadFotografos () {
      const url = `${baseApiUrl}/filtro-fotografos`
      axios.get(url).then(res => {
        this.fotografos = res.data.map(item => {
          return {
            value: item.id,
            text: item.nome
          }
        })
      })
    },
    loadAddVideo () {
      this.verCapUp = false
      this.video = 1
      this.loadAddFoto()
    },
    saveImage () {
      this.editImagem()
    },
    loadAddFoto () {
      this.foto.uuid = uuid.v1()
      this.foto.usuario = this.user.id
      this.foto.uuid_noticia = this.noticia.uuid
      this.foto.vinc_galeria = true
      // this.foto.vinc_noticia = false
      this.foto.uid_noticia = this.noticia.id
      this.foto.uid_galeria = this.galeria.id
      this.foto.uid_subcategoria = this.galeria.uid_subcategoria
      this.dateF()
      this.addFoto = true
      this.loadSubCategorias()
      this.loadFotografos()
    },
    loadFotos (idN) {
      const id = idN || this.galeria.id
      const url = `${baseApiUrl}/fotos-da-galeria/${id}`
      axios.get(url).then(res => {
        this.fotos = res.data.map(item => {
          return {
            ...item,
            publica: item.publico_privado === 0 ? 'Não' : 'Sim',
            slide: item.slide === 0 ? 'Não' : 'Sim',
            capa: item.capa === 0 ? 'Não' : 'Sim',
            noticia: item.vinc_noticia === 0 ? 'Não' : 'Sim',
            galeria: item.vinc_galeria === 0 ? 'Não' : 'Sim',
            inativar: item.inativar === 0 ? 'Ativo' : 'Inativo',
            data: moment(item.data_publicacao).format('DD/MM/YYYY')
          }
        })
      })
    },
    desvinculaGaleria () {
      const vinc = this.foto.vinc_galeria
      if (vinc === true) {
        this.foto.uid_galeria = this.galeria.id
      } else {
        this.foto.uid_galeria = null
      }
    },
    reset () {
      this.galeria = {}
      this.noticia = {}
      this.menus = {}
      this.fotos = []
      this.mode = 'save'
      this.nmenu = '[Menú não informado]'
      this.ntitulo = '[Título não informado]'
      this.codigo = ''
      this.codFoto = ''
      this.codNoticia = ''
      this.codMenu = ''
      this.loadUser()
      this.loadDatas()
    },
    loadUser () {
      this.galeria.uuid = uuid.v1()
      this.galeria.usuario = this.user.id
    },
    loadDatas () {
      const dataAgora = new Date().toISOString().substr(0, 10)
      this.data_publicacao = moment(dataAgora).format('DD/MM/YYYY')
      this.date = dataAgora
    }
  },
  created () {
    this.loadUser()
  },
  mounted () {
    const idGal = this.$route.params.id
    if (idGal) {
      const url = `${baseApiUrl}/galeria-de-noticia-update/${idGal}`
      axios.get(url).then(res => {
        this.galeria = res.data
        this.codigo = this.galeria.id
        const idN = this.galeria.uid_noticia
        this.loadNoticia(idN)
        this.loadFotos(idN)
      })
      this.mode = 'editar'
    }
  }
}
</script>
<style scoped>
.container {
  width: 98% !important;
}
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -13px !important;
}
.btn-outer-right-1 {
  margin-top: -8px !important;
  margin-left: -12px !important;
  border-top: solid 1px #878f97 !important;
  border-right: solid 1px #878f97 !important;
  border-bottom: solid 1px #878f97 !important;
}
.v-size--default {
  height: 39px !important;
  min-width: 38px !important;
}
</style>
